import { render, staticRenderFns } from "./ForgotPassword-v2.vue?vue&type=template&id=bf375c2a&scoped=true&"
import script from "./ForgotPassword-v2.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword-v2.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword-v2.vue?vue&type=style&index=0&id=bf375c2a&scoped=true&lang=css&"
import style1 from "./ForgotPassword-v2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf375c2a",
  null
  
)

export default component.exports